import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

export interface LocalOpcao {
  id: number;
  nome: string;
}

export interface TramitarDialogData {
  locais: LocalOpcao[];
  origemNome?: string;
}

export interface TramitarDialogResult {
  idLocalDestino: number;
  observacao: string;
}

@Component({
  standalone: true,
  selector: 'app-tramitar-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
  template: `
    <h2 mat-dialog-title>Tramitar Processo</h2>
    <form [formGroup]="form" (ngSubmit)="confirmar()">
      <mat-dialog-content class="conteudo">
        <p *ngIf="data.origemNome" class="origem">
          <strong>Local de origem:</strong> {{ data.origemNome }}
        </p>

        <mat-form-field appearance="outline" class="full">
          <mat-label>Local de destino</mat-label>
          <mat-select formControlName="idLocalDestino" required>
            <mat-option *ngFor="let l of data.locais" [value]="l.id">
              {{ l.nome }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full">
          <mat-label>Observação</mat-label>
          <textarea matInput formControlName="observacao" rows="4" required></textarea>
        </mat-form-field>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="cancelar()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
          Tramitar
        </button>
      </mat-dialog-actions>
    </form>
  `,
  styles: [
    `
      .conteudo {
        display: flex;
        flex-direction: column;
        min-width: 420px;
      }
      .full {
        width: 100%;
      }
      .origem {
        margin-bottom: 0.75rem;
        font-size: 0.9rem;
      }
    `,
  ],
})
export class TramitarDialogComponent {
  public form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<TramitarDialogComponent, TramitarDialogResult | null>,
    @Inject(MAT_DIALOG_DATA) public data: TramitarDialogData
  ) {
    this.form = this.fb.group({
      idLocalDestino: [null, Validators.required],
      observacao: ['', Validators.required],
    });
  }

  public confirmar(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.value);
  }

  public cancelar(): void {
    this.dialogRef.close(null);
  }
}
